import { AbsenceReportApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { TopEmployeesByRemainingDaysDto } from '../../../commonTypes/reports.types';
import { fetchAllReportRows } from '../../../util/exportHelper';

export interface IGetTopLeaveBalanceForExportQuery {
    leaveType: string;
    teamId?: string;
    projectId?: string;
    search?: string;
    sort: 'remainingDesc' | 'remainingAsc';
}

const useHttpGetTopEmployeeLeaveBalanceForExport = () => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);

    const exec = (query: IGetTopLeaveBalanceForExportQuery): Promise<TopEmployeesByRemainingDaysDto[]> =>
        fetchAllReportRows(
            (page, size) =>
                new Promise((resolve, reject) => {
                    const { exec } = absenceReportApi.getTopEmployeeLeaveBalance({
                        query: { ...query, page, size },
                        onSuccess: res => resolve(res.body),
                        onError: reject,
                    });
                    exec();
                })
        );

    return { exec };
};

export default useHttpGetTopEmployeeLeaveBalanceForExport;
